var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('button',{staticClass:"profile-btn dropbtn icon",attrs:{"id":"btn-navbar-profile"}},[_c('account-icon',{staticClass:"icon",on:{"click":_vm.redirectToProfileOrLogin}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }